import { render, staticRenderFns } from "./optionInput.vue?vue&type=template&id=1f34bf52&scoped=true"
import script from "./optionInput.vue?vue&type=script&lang=js"
export * from "./optionInput.vue?vue&type=script&lang=js"
import style0 from "./optionInput.vue?vue&type=style&index=0&id=1f34bf52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34bf52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
